import { render, staticRenderFns } from "./cowReportHome.vue?vue&type=template&id=19c0034a&scoped=true&"
import script from "./cowReportHome.vue?vue&type=script&lang=js&"
export * from "./cowReportHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0034a",
  null
  
)

export default component.exports